import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/search_icon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-e610840a")

_pushScopeId("data-v-e610840a")
const _hoisted_1 = { class: "search-input-view" }
const _hoisted_2 = { class: "commonSearchInputViewArea" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "commonSearchIconArea" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "commonSearchIcon",
    src: _imports_0
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createVNode("input", {
        class: "commonSearchText",
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.keywordComputed = $event)),
        onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.setFocusKeyword(...args))),
        placeholder: "レシピや食材で検索する"
      }, null, 544), [
        [_vModelText, _ctx.keywordComputed]
      ])
    ])
  ]))
})